export default __webpack_public_path__ + "static/media/ClientLogos.704a793a.png";